import { LeaderboardClient } from '@/components/market/leaderboard-client';
import { MarketHeader } from '@/components/market/market-header';
import type { MarketLeaderboard } from '@/types';

export default function Leaderboard({
  edition,
  initialState,
}: MarketLeaderboard) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-5 p-4 sm:p-6">
      <MarketHeader
        initialData={initialState}
        hackSlug={edition.slug}
        eventLabel={edition.eventLabel}
      />
      <LeaderboardClient />
    </div>
  );
}
